if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      connectedCallback() {
      }

      get selectedOptionValues() {
        const results = [];
        this.querySelectorAll('fieldset input[type="radio"]:checked').forEach(input => {
          if (input.dataset.optionValueId) results.push(input.dataset.optionValueId);
        });
        this.querySelectorAll('select').forEach(select => {
          const selected = select.options[select.selectedIndex];
          if (selected?.dataset.optionValueId) results.push(selected.dataset.optionValueId);
        });
        return results;
      }

      get pickupAvailability() {
        return this.closest('product-info')?.querySelector('pickup-availability');
      }
    }
  );
}